module.exports = __webpack_public_path__ + "78c11aa56f27989c1cc9e64a28ff7e5a.pdf";